import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { organizacionManualApi } from "@/features/organizacion-manual/services/organizacion-manual.api";

export const misOrganizacionesQueryOptions = () =>
  queryOptions({
    queryKey: qk.misOrganizaciones,
    queryFn: () => organizacionManualApi.listarMisOrganizaciones(),
    staleTime: 60_000,
  });

export function useMisOrganizaciones() {
  return useSuspenseQuery(misOrganizacionesQueryOptions());
}
